export default {'UNKNOWN': '?', 'ONE': '1', 'X': 'X', 'TWO': '2'};